import React, { useRef, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ImageBase from "./ImageBase";
import ImageFocalpointReticle from "./ImageFocalpointReticle";
import { getImagePointEvent } from "./utils/getImagePoint";
const useStyles = makeStyles(theme => ({
  root: {}
}));

const ImageFocalpoint = ({
  className,
  imageUrl,
  imageCropdata,
  imageFilters,
  imageFocalpoint = {
    x: 0,
    y: 0,
    left: 50,
    top: 50
  },
  onChange
}) => {
  const _useState = useState(imageFocalpoint),
        focalpoint = _useState[0],
        setFocalpoint = _useState[1];

  const handleClick = event => {
    imageFocalpoint = getImagePointEvent(event);
    setFocalpoint(imageFocalpoint);
    onChange && onChange(imageFocalpoint);
  };

  const classes = useStyles();

  if (!imageUrl) {
    return React.createElement("p", null, "No imageUrl for focalpoint");
  }

  return React.createElement(ImageBase, {
    imageUrl: imageUrl,
    imageCropdata: imageCropdata,
    imageFilters: imageFilters,
    onClick: handleClick
  }, React.createElement(ImageFocalpointReticle, focalpoint));
};

export default ImageFocalpoint;